document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-role="lpi-tab"]').forEach(tab => {
        tab.addEventListener('click', () => {
            Array.from(tab.parentNode.children).forEach(_tab => _tab.classList.remove('active'))
            tab.classList.toggle('active')
            document.querySelectorAll('[data-role="lpi-pane"][data-lpi-tab="tab' + tab.dataset.lpiTab + '"]').forEach(pane => pane.classList.add('active'))
            document.querySelectorAll('[data-role="lpi-pane"]:not([data-lpi-tab="tab' + tab.dataset.lpiTab + '"])').forEach(pane => pane.classList.remove('active'))
            const panes = document.querySelector('.lp-ingredients__panes')
            panes.classList.remove('cols2', 'cols3')
            panes.classList.add('cols' + tab.dataset.cols)
        })
    })
})
